// bd-deepcontext-zgbz — the Scheduled Jobs surface is English-only copy, and
// the locked design pins the number shapes ("1,000 × 4/day", "~2,100 URLs per
// run"). Bare `toLocaleString()` follows the visitor's browser locale, which
// renders those as "1 000" / "2.100" on a European machine and breaks the lock.
// Everything on this page formats through here instead.
export const grouped = (value: number): string =>
  value.toLocaleString("en-US");
